import ShimmerBadge from "./Badge";

export default ShimmerBadge;
